export interface RuleActionFormatterResolvers {
  resolveTag?: (id: string) => string | undefined;
  resolveUser?: (id: string) => string | undefined;
}

export interface FormattedLine {
  key: string;
  value: string;
}

export function formatRuleActionLines(
  action: any,
  resolvers?: RuleActionFormatterResolvers
): FormattedLine[] {
  if (!action) return [];

  const formattedLines: FormattedLine[] = [];
  const actionData = action.data;
  const actionCondition = action.condition;

  if (action.action === 'add-tag' && actionData?.tagId) {
    const resolvedTagLabel =
      resolvers?.resolveTag?.(actionData.tagId) || actionData.tagId;

    formattedLines.push({ key: 'tagId', value: String(resolvedTagLabel) });
  } else if (action.action === 'add-permission' && actionData?.permission) {
    const permissionValue = actionData.permission.permission;

    const resolvedUserLabel =
      resolvers?.resolveUser?.(actionData.permission.userId) ||
      actionData.permission.userId;

    formattedLines.push({ key: 'permission', value: String(permissionValue) });
    formattedLines.push({ key: 'userId', value: String(resolvedUserLabel) });
  } else if (action.action === 'add-alert' && actionData?.alert) {
    const recipientList = (actionData.alert.attributes?.recipients || []).join(
      ', '
    );
    const maxAgeValue = actionData.alert.attributes?.maxAge;

    formattedLines.push({
      key: 'alertType',
      value: String(actionData.alert.type),
    });
    formattedLines.push({ key: 'recipients', value: `[${recipientList}]` });
    formattedLines.push({ key: 'maxAge', value: String(maxAgeValue) });
  } else if (actionData) {
    try {
      formattedLines.push({ key: 'data', value: JSON.stringify(actionData) });
    } catch {
      formattedLines.push({ key: 'data', value: String(actionData) });
    }
  }

  if (actionCondition?.regex) {
    formattedLines.push({
      key: 'condition',
      value: `regex(${actionCondition.regex.attribute} ~ ${actionCondition.regex.regex})`,
    });
  } else if (actionCondition?.dsl) {
    formattedLines.push({
      key: 'condition',
      value: `dsl(${actionCondition.dsl.dsl})`,
    });
  }

  return formattedLines;
}
